import { useGqlQuery } from 'src/hooks/use-gql-query';
import query from './query.graphql';
import type { ProductMediaQuery, ProductMediaQueryVariables } from 'types';

export function useProductMedia(variables: ProductMediaQueryVariables) {
  return useGqlQuery<ProductMediaQuery>({
    queryKey: ['product', 'media'],
    query,
    variables,
  });
}
